import { Row, useDevice } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export function TextAndInlineSelectRow(_ref) {
  let {
    children,
    inline
  } = _ref;
  const {
    isMobileDevice
  } = useDevice();
  return /*#__PURE__*/_jsx(Row, {
    alignItems: "center",
    gap: 4,
    wrap: isMobileDevice,
    inline: inline,
    children: children
  });
}